import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M480-240 240-480l56-56 144 144v-368h80v368l144-144 56 56-240 240Z" }));
export default SvgArrowDown;
